import { Container } from "@mui/material";
import React from "react";

const Faq = () => {
  return <Container>faq</Container>;
};

export default Faq;
